import script from "./ExpressFeeBtn.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExpressFeeBtn.vue?vue&type=script&lang=ts&setup=true"

import "./ExpressFeeBtn.vue?vue&type=style&index=0&id=874eb1e8&lang=scss"

const __exports__ = script;

export default __exports__